<template>

  <div class="container-fluid">
    <div class="page-heading mb-4">
      <p class="page-eyebrow">ENGAGEMENT</p>
      <h1 class="h3 mb-1 text-gray-800">Broadcast notification</h1>
      <p class="mb-0 text-muted">Send a timely message to delegates about an event or quiz.</p>
    </div>

    <BroadcastNotificationForm></BroadcastNotificationForm>
  </div>



</template>

<style scoped>
.page-heading{border-bottom:1px solid #e2e6ea;padding-bottom:1rem}.page-eyebrow{color:#426cc6;font-size:.72rem;font-weight:700;letter-spacing:.08em;margin:0 0 .35rem}
</style>


<script>
import BroadcastNotificationForm from "@/components/message/BroadcastNotificationForm.vue";

export default {
  name: "BroadcastNotificationAddPage",
  components: {BroadcastNotificationForm},
}
</script>
